export const AddEmployee = 'Add Employees';
export const AddProjects = 'Add Project';
export const Cancel = 'Cancel';
export const Submit = 'Submit';
export const SearchProject = 'Search Project';
export const SearchEmployee = 'Search Employee';
export const SearchByLabel = 'Search By';
export const SEARCH_BY = {
  PROJECT_NAME: 'projectName',
  EMPLOYEE_NAME: 'employeeName',
};
export const SEARCH_BY_OPTIONS = [
  { value: SEARCH_BY.PROJECT_NAME, label: 'Project Name' },
  { value: SEARCH_BY.EMPLOYEE_NAME, label: 'Employee Name' },
];
export const NO_PROJECTS = 'No Projects';
export const EmployeeRole = {
  NONE: 'NONE',
  LEAD: 'LEAD',
  SHADOW: 'SHADOW',
  UI_DEV: 'UI DEVELOPER',
  BACKEND_DEV: 'BACKEND ',
};
